<template>
	<div class="contentPage bg_page_color">
		<mt-header class="header" :title="row.title" v-show="type !== 0 ? true : false">
			<router-link>
			  	<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right"></mt-button>
		</mt-header>
		<div class="margin_header content_container">
			<div class="title">{{row.title}}</div>
			<div class="content page_padding" v-html="row.content"></div>
		</div>
		<a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzkzODAzMjA2Ml80ODI0ODlfNDAwNjc1NDMwMF8yXw" class="concatUs" @click="clickQQ()" v-show="equiData.isMatch !== 1">
			<div class="qq_icon">
				<img :src="images.qq"/>
			</div>
			<span class="text">联系我们</span>
			<span class="time">（工作日 9：00——18：00）</span>
		</a>

		<div class="bottom-link" v-show="equiData.isMatch == 1">
			<a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzkzODAzMjA2Ml80ODI0ODlfNDAwNjc1NDMwMF8yXw" @click="clickQQ()" class="link">
				<span>联系我们</span>
			</a>
			<div class="currentEqui" v-show="equiData.isMatch == 0 ? false:true" v-on:click="toEquiHome()">
				<div class="equi-icon">
					<img :src="equiData.image"/>
				</div>
				<h6>{{equiData.title}}</h6>
			</div>
		</div>
	</div>
</template>

<script>
	import { Indicator, MessageBox } from 'mint-ui';
	import { get } from 'assets/api/config'

	var img = {};
	img.qq = require('../../assets/images/faq/QQ.png');

	export default {
//  name: 'content',
    data () {
      return {
      	images:img,
      	equiData:'',//数据
      	title:'',
        row: '',
        type:''
      }
    },

    activated: function () {
    	window.scrollTo(0,0);

    	let that = this;
    	//loading
		Indicator.open({
		  	spinnerType: 'fading-circle'
		});

    	//获取传值信息
      	let id = this.$route.params.id
      	console.log("id:",id)

		let data = {
			token : id,
			act:'faqDetail'
		}

		get(data).then(function(res) {
			//关闭loading
			Indicator.close();
			if(res.msg !== '成功'){
				MessageBox.alert('获取数据失败').then(action => {
		  			return;
				});
			}

			that.equiData = res.data;
			that.row = res.data.row;
		});

		if(window.JsOperation != undefined){
			//anzhuo
			this.type = 0;
		}



		let time = setInterval(function(){
			if(document.getElementsByClassName("bilibili") != null){
				clearInterval(time);

				let bilibili = document.getElementsByClassName("bilibili");

				for(let i in bilibili){
					bilibili[i].addEventListener('click',function(){
						if(this.innerHTML != "" && this.innerHTML != "<br>"){
							let href = this.getAttribute("href");
							that.toLink(href);
						}

					});
				}
			}
		},1000)

    },

    methods: {
		clickQQ(e){
			if(window.JsOperation){
				//安卓情况下
				if (e && e.preventDefault){
		            e.preventDefault();
		       	}else{
		            window.event.returnValue = false; //兼容IE
		       	}
				window.JsOperation.clickQQ()
			}
//			else if(!device.isIos){
//				goDownApp();
//			}

		},
		toLink(href){
			if(window.JsOperation){
				window.JsOperation.clickToBrowser(href)
			}
		}
    }
  }
</script>

<style lang="less">
	.header{
		background-color: #ce3d3e !important;
		z-index: 999;
		height: 120px !important;

		.mint-header-title{
			font-size: 40px !important;
		}

		.mintui{
			font-size: 40px !important;
		}
	}

	iframe{
		width: 100% !important;
		max-height: 1000px !important;
		min-height: 300px !important;
	}

	.page_padding{
	    padding-bottom: 170px;
	}

	.margin_header{
		margin-top:8px;
	}

	.content_container{
		width: 100%;
		overflow: hidden;
		text-align: center;

		.title{
			margin: 125px 0;
			font-size: 50px;
		}

		.content{
			padding: 0 46px 170px 46px;
			font-size: 40px;
			line-height: 66px;
			color: #666666;
			text-align: left;

			img{
				width: 100% !important;
				height: auto !important;
			}
		}
	}

	.concatUs {
		position: fixed;
		bottom: 0;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 146px;
		line-height: 146px;
		text-align: center;
		background-color: #FFFFFF;
		border-top: 1px solid #F6F6F6;
		text-decoration: none;
		.qq_icon {
			display: flex;
			width: 89px;
			height: 89px;
			margin-right: 25px;

			img {
				display: inline-block;
				vertical-align: middle;
				width: 100%;
				height: 100%;
			}
		}
		.text{
			height: 100%;
			font-size: 40px;
			line-height: 160px;
			color: #333333;
		}

		.time{
			height: 100%;
			font-size: 36px;
			line-height: 158px;
			color: #999999;
		}
	}

	/*匹配到手柄的*/
	.bottom-link{
		position: fixed;
	    bottom: 0;
	    width: 100%;
	    height: 146px;
	    line-height: 146px;
		display: flex;
		background-color: #FFFFFF;
	    border-top: 1px solid #F6F6F6;
	    font-size: 40px;

		.link{
			display: block;
			width: 50%;
			border-right: 3px #f6f6f6 solid;
			text-decoration: none;
			color: #333333;

			span{
				display: block;
				width: 100%;
			}
		}

		.currentEqui{
			display: flex;
			justify-content: center;
			align-items: center;
			width: 50%;

			.equi-icon{
				width: 110px;
				margin-right:20px;
				display: flex;
			    justify-content: center;
			    align-items: center;

				img{
					width: 100%;
				}
			}

			h6{
				color: #333333;
			}
		}
	}
  @media screen and (min-width: 700px) {
    .contentPage {
      background-color: #f7f7f7;
      height: 100%;
      .header {
        margin: 0 auto;
        height: 66PX !important;
        width: 668PX;
        font-size: 24PX !important;
      }
      .header .mint-header-title, .header .mintui {
        font-size: 24PX !important;
      }
      .content_container .title {
        margin: 10PX 0;
        font-size: 22PX;
      }
      .content_container .content {
        width: 648PX;
        margin: 0 auto;
        padding: 0 10PX;
        font-size: 18PX;
        line-height: 26PX;
        padding-bottom: 50PX;
      }
      .concatUs {
        height: 50PX;
        line-height: 50PX;
        .qq_icon {
          width: 26PX;
          height: 26PX;
        }
        .text, .time {
          font-size: 16PX;
          line-height: 50PX;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/FAQ/content.vue